var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { id: "payment-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitHandler.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { attrs: { id: "payment-element" } }),
      _vm._v(" "),
      _c("div", { staticClass: "hidden", attrs: { id: "payment-message" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }